import { FunctionComponent } from 'react';
import { Board } from '../../basicComponents/board/Board';
import { usePlayers } from '../../hooks/usePlayers';
import styled from 'styled-components';
export const SimpleGame = styled('div')`
  max-width: 400px;
  min-width: 200px;
  width: 100%;
  min-height: 400px;
  margin: 15px auto 40px auto;
  padding: 20px;
  background-color: #ffffff;
  background-size: 2% 2%;
  color: black;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  position: relative;
  left: 4px;
  top: 4px;
  box-shadow: #5555 0px 0px 20px 0px;
`;


export const GameBoard: FunctionComponent<{ noBoard?: boolean, children?: React.ReactNode }> = ({ noBoard, children }) => {
  const { players, turnPlayer } = usePlayers();

  return noBoard ? (
    <SimpleGame>
      {children}
    </SimpleGame>
  ) 
  :(
    <Board>
      <Board.Background />
      <Board.Middle>{children}</Board.Middle>
      {players
        .filter((p) => p.isReady)
        .map(({ id, steps, avatar }) => (
          <Board.Step
            count={players.reduce(
              (count, player) =>
                player.steps === steps ? (player.isReady ? count + 1 : count) : count,
              0
            )}
            isTurn={turnPlayer?.avatar === avatar}
            key={id}
            step={steps}
          >
            <Board.Avatar variant={avatar} />
          </Board.Step>
        ))}
    </Board>
  );
};
